export default __webpack_public_path__ + "static/media/telegram.beb56b86.png";